// extracted by mini-css-extract-plugin
export default {"wrapper":"CorrectAnswer_wrapper__ScLWJ","select":"CorrectAnswer_select__fJa+Y"};